import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../../../context';

const CodeLocationSelector = () => {
    // TODO: do proper diffing
    const daylightLocations = useSelector(state => state.daylight.daylightLocations, shallowEqual);
    const codeLocationFilter = useSelector(state => state.daylight.codeLocationFilter);
    const dispatch = useDispatch();
    const setCodeLocationFilter = (string) => dispatch(actions.daylight.setCodeLocationFilter(string));
    return (
        <th className="col col-small">
            <select
                className="p-1 rounded w-100"
                value={codeLocationFilter}
                onChange={(e) => setCodeLocationFilter(e.target.value)}>
                <option value="">All</option>
                <option disabled>Location:</option>
                {/* TODO: make sure c is unique */}
                {daylightLocations?.map((c, x) => (
                    <option key={c} value={c}>
                        {c}
                    </option>
                ))}
            </select>
        </th>
    );
};

export default CodeLocationSelector;
